<!--
 * @Description: 批次赋码追溯
 * @Author: lufenggang
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 09:52:52
 * @LastEditTime: 2020-12-30 16:32:12
-->
<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        批次赋码追溯
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExport"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.inStorageCode">
            <el-input
              v-model="slotForms.forms.inStorageCode"
              placeholder="入库/出库编号"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          label="入库/出库编号"
          min-width="150"
          prop="warehouseCode"
          fixed
          align="center"
        >
          <template slot-scope="scope">
            <span class="links" @click="handleCode(scope.row)">
              {{ scope.row.warehouseCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="类型"
          min-width="150"
          prop="warehouseTypeStr"
          align="center"
        ></el-table-column>
        <el-table-column
          label="商品数量"
          min-width="150"
          prop="warehouseNumStr"
          align="center"
        ></el-table-column>
        <el-table-column
          label="赋码数量"
          min-width="150"
          prop="tagCodeNum"
          align="center"
        ></el-table-column>
        <el-table-column
          label="赋码时间"
          min-width="150"
          prop="tagTime"
          align="center"
        ></el-table-column>
        <el-table-column
          label="批次查询次数"
          min-width="100"
          prop="batchQueryTimes"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.batchQueryTimes > 0"
              class="links"
              @click="handleFrequency(scope.row)"
            >
              {{ scope.row.batchQueryTimes }}
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >赋码详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 批次查询详情 -->
    <el-dialog
      class="batch-dialog"
      title="批次查询详情"
      :visible.sync="dialogBatchVisible"
      width="490px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="wrapper" v-loading="loadingDialog">
        <h4>
          入库编号：<span>{{ inStorageCode }}</span>
        </h4>
        <div class="batch-list">
          <el-table :data="batchList" border style="width: 100%" height="100%">
            <el-table-column
              label="序号"
              width="80"
              fixed
              type="index"
            ></el-table-column>
            <el-table-column
              prop="queryTime"
              label="查询时间"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="ip" label="查询IP" width="180" align="left">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBatchVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 赋码详情 -->
    <el-dialog
      class="batch-dialog"
      title="赋码详情"
      :visible.sync="dialogDetailsVisible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="wrapper" v-loading="loadingDialog">
        <h4>
          入库编号：<span>{{ inStorageCode }}</span>
        </h4>
        <div class="batch-details-list">
          <div
            class="batch-item"
            v-for="item in batchDetailsList"
            :key="item.key"
          >
            <qrcode-vue
              :value="`${item.tagCode}`"
              :size="80"
              level="H"
            ></qrcode-vue>
            <span class="links" @click="handleJump(item)">{{
              item.tagCode
            }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailsVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  batchTrace,
  exportBatchTrace,
  tagCodeDetail,
  tagCodeQueryRecord
} from "@/api/goodsTrace/batchQrcodeTrace";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { exportXlsx } from "@/utils/exportXlsx.js";
import qrcodeVue from "qrcode.vue";
export default {
  name: "goodsTraceBatchQrcode",
  mixins: [resizeListener, operationManage],
  components: {
    qrcodeVue
  },
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          inStorageCode: "" //入库编号
        },
        extends: []
      },
      inStorageCode: "",
      loadingDialog: false,
      dialogBatchVisible: false,
      dialogDetailsVisible: false,
      batchList: [],
      batchDetailsList: [],
      formsExtend: [],
      tableData: [],
      loading: false
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    let { code } = this.$route.query;
    if (code) {
      this.formExtend.forms.inStorageCode = code;
    }
    // 查询列表数据
    this.fetchFindByPage(this.mergeObj());
    //查询搜索条件
    this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    //跳转到查看追溯详情页面
    handleJump(row) {
      let { tagCode, codeId } = row;
      //跳转路由
      const { href } = this.$router.resolve({
        path: "/goodsTraceWholeProcess",
        query: {
          tagCode
        }
      });
      window.open(href, "_blank");
    },
    //入库编号跳转
    handleCode(row) {
      let { warehouseCode, tagTime, warehouseType } = row;
      let url =
        warehouseType === 1
          ? "/goodsTraceInflowBatch"
          : "/goodsTraceOutflowBatch";
      //跳转路由
      const { href } = this.$router.resolve({
        path: url,
        query: {
          warehouseCode,
          tagTime
        }
      });
      window.open(href, "_blank");
    },
    //批次查询次数
    handleFrequency(row) {
      this.dialogBatchVisible = true;
      let params = this.getParams(row);
      tagCodeQueryRecord(params)
        .then(res => {
          let { code, result } = res;
          if (result && code === 1 && Array.isArray(result)) {
            this.batchList = result;
          }
          this.loadingDialog = false;
        })
        .catch(error => {
          this.loadingDialog = false;
          console.log(error);
        });
    },
    //获取参数
    getParams(row) {
      this.loadingDialog = true;
      let { warehouseId, warehouseType, warehouseCode } = row;
      this.inStorageCode = warehouseCode;
      return {
        warehouseId,
        warehouseType
      };
    },
    //赋码详情
    handleClick(row) {
      this.dialogDetailsVisible = true;
      let params = this.getParams(row);
      tagCodeDetail(params)
        .then(res => {
          let { code, result } = res;
          if (result && code === 1 && Array.isArray(result)) {
            this.batchDetailsList = result;
          }
          this.loadingDialog = false;
        })
        .catch(error => {
          this.loadingDialog = false;
          console.log(error);
        });
    },
    // 获取表格数据
    fetchFindByPage(params) {
      this.loading = true;
      let total = 0;
      let tableData = [];
      batchTrace(params)
        .then(res => {
          let {
            code,
            result: { data, totalRecords }
          } = res;
          if (res.result && code === 1 && Array.isArray(data)) {
            tableData = data;
            total = totalRecords;
          }
          this.tableData = tableData;
          this.total = total;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 导出excel 表格
    handleExport() {
      let params = this.mergeObj();
      this.exportData(params);
    },
    // 导出页面数据接口请求
    async exportData(params) {
      try {
        exportBatchTrace(params).then(res => {
          // 导出
          exportXlsx(res, `批次赋码追溯.xls`);
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.fetchFindByPage(this.mergeObj());
    },
    // 重置
    handleResetForm() {
      this.formExtend.forms.inStorageCode = "";
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.fetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.fetchFindByPage(this.mergeObj());
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0099ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
/deep/ .batch-dialog {
  .el-dialog {
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__body {
      padding: 0 20px;
      overflow-y: scroll;
      height: 300px;
      h4 {
        margin: 10px 0;
      }
      .batch-list {
        height: 260px;
        overflow-y: auto;
      }
      .batch-details-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        padding: 10px 0;
        .batch-item {
          width: 20%;
          text-align: center;
          span {
            padding: 10px 0 0 0;
            display: block;
          }
        }
      }
    }

    .el-dialog__header {
      padding: 10px;
      background-color: #efefef;
    }
    .el-dialog__footer {
      text-align: center;
      padding: 10px 20px 10px;
    }
  }
}
</style>
